
const CLS = 'productListingBlock';
const BLK = '.' + CLS + '-';
const CLS_LIST_ADDED = 'has-added';
const CLS_ACTIVE = 'is-active';

import * as Api from '../../../../global/js/api';
import * as wishlist from '../../../../global/js/wishlist';
import * as giftRegistry from '../../../../global/js/giftRegistry';
import * as utils from '../../../../global/js/utils';
import Handlebars from 'handlebars';
import { loadNotifications } from '../../../widgets/notifications/js/loadWg';
import '../../../../global/helpers/obj';
import * as dataLayer from '../../../../global/js/dataLayer';
import { addToCart } from '../../../../global/js/cart';
import 'slick-carousel';
import {DISCLAIMER_TEXT, EVENT_PRODUCT_QUICKVEW_SHOW} from '../../../../global/js/constants';
import {QuantityInput} from '../../../widgets/quantityInput/js/quantityInput';

/**
 * Clone logic form ProductListingBlock.js
 */
export class ProductQuickView {
	constructor($el) {
		this.$el = $el;
		this.$blk = $($el);
	}

	init() {
		window.productData = {};
		this.searchParamsObj = new URLSearchParams(location.search);
		this.setProductQuickView();
		this.handleQuickViewClick();
	}

	handleQuickViewClick() {
		const That = this;
		klevu.coreEvent.attach("setRemoteConfigLanding", {
			name: "product-quick-view",
			fire: function () {
				klevu.search.landing.getScope().chains.template.render.add({
					name: "handleButtonQuickView",
					fire: function (data, scope) {
						klevu.each(document.querySelectorAll('.klevuProductQuickView'), function (_, button) {
							button.addEventListener('click', function () {
								const itemId = $(this).data('item-id');
								const productImage = $(this).data('product-image');
								That.showQuickView(itemId, productImage);
							});
						});
					}
				});
			}
		});

		this.$blk.on(EVENT_PRODUCT_QUICKVEW_SHOW, (_, {itemId, productImage}) => {
			That.showQuickView(itemId, productImage);
		});
	}

	setProductQuickView() {
		const That = this;
		let $this = $(this.$el);

		$this.on('click', '.quickView-btn', function () {
			That.prodId = $(this).closest('.productItem').data('itemId');
			That.prodImg = $(this).closest('.productItem').data('thumbImg');

			That.launchPopup();
		});

		$this.on('click', '.add-to-cart', function () {
			if (That.saleAvailability === 'ISOOP' || That.saleAvailability === 'ISONP') {
				window.location.assign(That.contactUsPageLink);
			} else {
				That.modal = $(this).closest('.modal');
				That.addToBag();
			}
		});
	}

	showQuickView(itemId, prodImg) {
		this.prodId = itemId;
		this.prodImg = prodImg;
		this.launchPopup();
	}

	setVisibleProduct() {
		const That = this;
		let $modal = $(`${BLK}modal`);
		let colors = $modal.find(`${BLK}options.colors`).find(BLK + 'option');

		if (colors.length > 0) {
			let colorTxt = colors.first().data('itemDescription');
			let $firstColor = colors.first();
			let selVariantCode = $firstColor.data('variant-code');
			let $parentSize = $modal.find(`${BLK}optionsWrapper[data-parent-itemid="${selVariantCode}"]`);

			$firstColor.trigger('click');

			if ($parentSize.length > 0) {
				let sizes = $parentSize.find(`${BLK}options.sizes .item-size`);

				// if there's only one size option, tick it
				if (sizes.length === 1) {
					That.noDLPush = true;
					sizes.first().trigger('click');
				}
			}
		}
	}

	templatePopupQuickView(data) {
		let colours = data.colors.items;
		if (colours && colours.length) {
			colours.forEach((item, index) => {
				if (item.hexColour) {
					let splitColourSwatch = item.hexColour.split(',');
					colours[index].arrColourSwatch = splitColourSwatch;
					colours[index].firstColor = splitColourSwatch[0];
					colours[index].secondColor = splitColourSwatch[1];
					colours[index].thirdColor = splitColourSwatch[2];
				}
			});
		}
		console.log(data);
		let $this = $(this.$el);
		const That = this;
		let starRating = require('../../../widgets/starRating/tmpl/starRating.hbs');
		Handlebars.registerPartial('starRating', starRating);
		let quantityInput = require('../../../widgets/quantityInput/tmpl/quantityInput.hbs');
		Handlebars.registerPartial('quantityInput', quantityInput);
		let paymentInfo = require('../../../widgets/paymentInfo/tmpl/paymentInfo.hbs');
		Handlebars.registerPartial('paymentInfo', paymentInfo);
		data['thumbImg'] = That.prodImg;
		let templateColor = `
		{{#if colors}}
		<div class="${CLS}-optionsWrapper {{#if sizes}}{{else}}mb-3{{/if}}">
			<div class="${CLS}-optionsTextWrapper">
				<strong>Colour: </strong>
				<span class="${CLS}-optionText"></span>
			</div>
			<div class="${CLS}-options colors">
				{{#each colors.items as |item|}}
				<div class="${CLS}-option {{#if sizes}}has-sizes{{/if}} {{#if hexColour}}is-hexColour{{/if}}" data-item-description="{{colourName}}" data-variant-code="{{colourCode}}" data-sku="{{sku}}" data-australianvendor="{{isAustralianVendor}}">
					{{#if imageUrl}}
						<img src="{{imageUrl}}" alt="{{colourName}}" />
					{{else if hexColour}}
						{{#if  (eq item.arrColourSwatch.length 3)}}
							<span class="hexColour" style="background: conic-gradient({{item.secondColor}} 120deg, {{item.thirdColor}} 120deg 240deg, {{item.firstColor}} 240deg 360deg); border: 1px solid #d6d6d6;"></span>
						{{else if  (eq item.arrColourSwatch.length 2)}}
							<span class="hexColour" style="background: linear-gradient(135deg, {{item.firstColor}} 50%, {{item.secondColor}} 50%); border: 1px solid #d6d6d6;"></span>
						{{else}}
							<span class="hexColour" style="background-color:{{item.hexColour}}; border: 1px solid #d6d6d6;"></span>
						{{/if}}
					{{else if variantImageUrl}}
						<img src="{{variantImageUrl}}" alt="{{colourName}}" />
					{{/if}}
					<div class="${CLS}-shadow"></div>
				</div>
				{{/each}}
			</div>
		</div>
		{{/if}}
		`;

		let templateSize = `
		{{#if sizes}}
		<div class="${CLS}-optionsWrapper">
			<div class="${CLS}-optionsTextWrapper">
				<strong>Size: </strong>
				<span class="${CLS}-optionText"></span>
			</div>
			<div class="${CLS}-options sizes">
				{{#each sizes.items}}
				<div class="${CLS}-option item-size" data-item-description="{{sizeDescription}}" data-variant-code="{{sizeCode}}" data-sku="{{sku}}" data-australianvendor="{{isAustralianVendor}}">
					{{sizeDescription}}
				</div>
				{{/each}}
			</div>
		</div>
		{{/if}}
		`;

		let templateGeneric = `
		{{#if colors}}
		{{else}}
		{{#if sizes}}
		{{else}}
		{{#if variants}}
		<div class="${CLS}-optionsWrapper">
			<div class="${CLS}-options">
				{{#each variants}}
				<div class="${CLS}-option generic" data-variant-code="{{code}}" data-sku="{{code}}" data-australianvendor="{{isAustralianVendor}}">
				{{#each images}}
					{{#if @first}}
					<img src="{{thumb}}" alt="{{../code}}" />
					{{/if}}
				{{/each}}
				<div class="${CLS}-shadow"></div>
				</div>
				{{/each}}
			</div>
		</div>
		{{/if}}
		{{/if}}
		{{/if}}
		`;

		let templateMarkup = `
			<div class="row">
				<div class="col-12 col-md-5 ${CLS}-productPhoto">
					{{!-- image slider holder --}}
					{{!--
					{{#if colors}}
					<div class="${CLS}-imgSlider">
						{{#each colors.items}}
						<div class="${CLS}-slide">
							<img src="{{url}}" alt="{{description}}" />
						</div>
						{{/each}}
					</div>
					{{else}}
					<img class="img-fluid" src="{{thumbImg}}">
					{{/if}}
					--}}
					<img class="img-fluid product-img d-none" src="{{thumbImg}}">
					<div class="${CLS}-imgSlider"></div>
					{{!--
					<div class="${CLS}-imgThumbs"></div>
					--}}
				</div>
				<div class="col-12 col-md-7">
					<h3 class="prod-title">{{title}}</h3>
					<div class="${CLS}-modal__price-detail"></div>
					<div class="${CLS}-bonus-buy"></div>
					<div class="${CLS}-modal__paymentInfo">
						{{> paymentInfo
							items=paymentInfo
							wg="paymentInfo"
							ns="PaymentInfo"
						}}
					</div>
					<div class="row">
						<div class="col-12 col-md-8 ${CLS}-reviews">
							{{> starRating
								wg="starRating"
								ns="StarRating"
								starPercentage="percent-80"
							}}
							{{#if reviews}}
							<span class="${CLS}-reviewsCount review-text">{{reviews}} Reviews</span>
							<span class="review-text is-seperator">|</span>
							<span class="review-text"><a href="#">Write a review</a></span>
							{{/if}}
						</div>
					</div>

					<div class="${CLS}-addThis mt-3">
						<section class="shareBtns " data-wg="ShareBtns">
							<div class="shareBtns-label">Share:</div>
							<div class="shareBtns-addThisWrap">
								<div class="addthis_inline_share_toolbox"></div>
							</div>
						</section>
					</div>
					<hr>

					<!-- Toggle class is-active to show / hide errors -->
					<div class="error-messages add-to-cart-errors"></div>

					{{!-- if only color --}}
					{{#if (eq type 'color')}}
						{{#if (gt colors.items.length 1)}}
						{{#if colors}}
								${templateColor}
						{{/if}}
						{{/if}}
					{{/if}}

					{{!-- if color size --}}
					{{#if (eq type 'colorsize')}}
						{{#if colors}}
							${templateColor}
						{{#each colors.items }}

						{{#if sizes}}

						<div data-parent-itemid="{{colourCode}}" class="${CLS}-optionsWrapper mt-2 {{#if @first}}{{else}}d-none{{/if}}">
							<div class="${CLS}-optionsTextWrapper">
								<strong>Size: </strong>
								<span class="${CLS}-optionText"></span>
							</div>
							<div class="${CLS}-options sizes">
								{{#each sizes.items}}
								<div class="${CLS}-option item-size" data-australianvendor="{{isAustralianVendor}}" data-item-description="{{sizeDescription}}" data-variant-code="{{sizeCode}}" data-sku="{{sku}}">
									{{sizeDescription}}
								</div>
								{{/each}}
							</div>
						</div>
						{{/if}}
						{{/each}}
						{{/if}}
					{{/if}}

					{{!-- if only size --}}
					{{#if (eq type 'size')}}
						{{#if (gt sizes.items.length 1)}}
						{{#if sizes}}
								${templateSize}
						{{/if}}
						{{/if}}
					{{/if}}

					{{#if variants}}
						{{#if (gt variants.length 1)}}
							${templateGeneric}
						{{/if}}
					{{/if}}

					<div class="${CLS}-optionsWrapper">
						<div class="${CLS}-optionsTextWrapper">
							<strong>Quantity: </strong>
							{{> quantityInput mods="is-36"
								wg="quantityInput"
								ns="QuantityInput"
								min="1"
								step="1"
								defaultValue="1"
							}}
						</div>
					</div>
					<div class="${CLS}-btns">
						<button type="button" data-item-id="{{itemId}}" class="button-btn button--primary add-to-cart btn-block btn--upperCase" title="Add to cart">Add To Cart</button>
						<button type="button" data-item-id="{{itemId}}" class="wishlistBtn button-btn button--btnOutline-primary ${data.isAddedWishlist ? CLS_LIST_ADDED : ''}" title="Add to wishlist">
							<span class="icon-heart"></span>
							<span class="icon-heart-outline"></span>
						</button>
						{{#if hasActiveGiftRegistry}}
						<button type="button" data-item-id="{{itemId}}" class="addToGiftBtn button-btn button--btnOutline-primary ${data.isAddedIntoGiftRegistry ? CLS_LIST_ADDED : ''}" title="Add to gift registry">
							<span class="icon-gift"></span>
						</button>
						{{/if}}
					</div>
					{{#if enableAustraliaSupplier}}
					<div class="d-none mt-3 australian-vendor">
						<div class="au-desc normal  {{#if isHeavy}}d-none{{/if}}" {{#if australianVendorDisclaimerTextColorItem}} style="color: {{australianVendorDisclaimerTextColorItem}}"{{/if}}>
							<i class="icon-exclamation-circle"></i>
							{{australianVendorDisclaimerTextItem}}
						</div>
						<div class="au-desc heavy {{#if isHeavy}}{{else}}d-none{{/if}}" {{#if australianVendorDisclaimerTextColorHeavyItem}} style="color: {{australianVendorDisclaimerTextColorHeavyItem}}"{{/if}}>
							<i class="icon-exclamation-circle"></i>
							{{australianVendorDisclaimerTextHeavyItem}}
						</div>
					</div>
					{{/if}}
					<hr>
					{{#if clickCollectMessage}}
					<div class="${CLS}-clickCollectMessage">{{clickCollectMessage}}</div>
					<hr>
					{{/if}}
					<a href="{{url}}" class="button-btn btn-block button--btnLink button--small">See all details</a>
				</div>
			</div>
			`;

		let precompiled = new Function('return ' + Handlebars.precompile(templateMarkup))();
		let theTemplate = Handlebars.template(precompiled);
		let theCompiledHtml = theTemplate(data);
		let $modal = $this.find(BLK + 'modal');
		$modal.find('.modal-body').html(theCompiledHtml);

		// set default product options in case there is only one option
		$modal.find(BLK + 'optionsWrapper').each(function () {
			let $this = $(this);
			let options = $this.find(BLK + 'option');
			if (options.length === 1) {
				options.addClass('is-active is-active-variant');
			}
		});

		// Re-init script for quantity input widget
		$modal.find('[data-wg="QuantityInput"]').each(function() {
			new QuantityInput(this).init();
		});
	}

	launchPopup() {
		let That = this;
		let $this = $(this.$el);
		$('.loading-spinner.plp-spinner').addClass('is-active');
		let prodId = That.prodId;
		let $modal = $this.find(BLK + 'modal');
		That.modal = $modal;

		// set modal itemCode
		$modal.attr('data-item-code', prodId);

		// get clicks on options
		$modal.on('click', BLK + 'option', function() {
			if (!$(this).hasClass('is-active-variant')) {
				That.wasNotActive = true;
			}

			// keep the current selected size
			That.currentVariant = {
				size: '',
				color: '',
			};

			That.currentVariant.size = $modal.find(BLK + 'option.item-size.is-active.is-active-variant:visible').attr('data-item-description') || '';

			if ($(this).parent().hasClass('colors')) {
				That.currentVariant.color = $(this).attr('data-variant-code');
				// when change the color, if the selected size existed then make the size 'active'
				let sizeNodeList = $modal.find(`[data-parent-itemid="${That.currentVariant.color}"]`).find(BLK + 'options').children();
				for (let i = 0; i < sizeNodeList.length; i++) {
					if ($(sizeNodeList[i]).attr('data-item-description') == That.currentVariant.size) {
						// keep existing the size selection
						$(sizeNodeList[i]).addClass('is-active');
						$(sizeNodeList[i]).addClass('is-active-variant');
					} else {
						// remove active selection
						$(sizeNodeList[i]).removeClass('is-active');
						$(sizeNodeList[i]).removeClass('is-active-variant');
					}
				}
			} else {
				That.currentVariant.size = $(this).attr('data-item-description');
			}

			// check if this option has sizes then show the size with the same product id
			let variantCode;
			let curVariantCode = $modal.attr('data-variant-code');



			let desc = $(this).data('itemDescription');

			$(this).closest(BLK + 'optionsWrapper').find(BLK + 'optionText').text(desc);
			$(this).closest(BLK + 'optionsWrapper').find(BLK + 'option:not(.slide)').removeClass('is-active');

			$(this).closest(BLK + 'optionsWrapper').find(BLK + 'option').removeClass('is-active-variant');
			$(this).addClass('is-active-variant');

			// cleanup styles
			$(this).not('.slide').addClass('is-active');

			if (That.prodType !== 'colorsize') {
				// call variant
				That.getVariantCode();
			}
			if (That.prodType !== 'color' || That.prodType !== 'size') {
				variantCode = $(this).data('sku');
			}

			if ($(this).hasClass('has-sizes')) {
				let itemCode = $(this).data('variantCode');
				$modal.find('[data-parent-itemid]').addClass('d-none');
				$modal.find('[data-parent-itemid="' + itemCode + '"]').removeClass('d-none');
				variantCode = $modal.find(BLK + 'optionsWrapper:not(.d-none) .sizes .is-active-variant').attr('data-sku');
				let sizeTextActive = $modal.find(BLK + 'optionsWrapper:not(.d-none) .sizes .is-active-variant').text();
				$modal.find('[data-parent-itemid="' + itemCode + '"]').find(BLK + 'optionText').text(sizeTextActive);
				variantCode = That.modal.find(BLK + 'optionsWrapper:not(.d-none) .productListingBlock-option.item-size.is-active-variant').attr('data-sku');
				if (!variantCode) variantCode = $(this).data('sku');
			}

			if (variantCode) {
				$modal.attr('data-variant-code', variantCode);
			}

			if ((curVariantCode !== variantCode) || That.wasNotActive) {
				$modal.trigger('variantChanged');
			}

			if ($modal.attr('data-variant-code') && $modal.attr('data-variant-code') != '') {
				if (That.saleAvailability !== 'ISONP') {
					That.setPrice();
					That.setBonusBuy();
				}
			}

			That.wasNotActive = false;
		});

		// do the slider stuff here
		// then show the modal once everything is ready
		// the api call returns variants and their images in an array
		// it also returns images as an array for the default (main variant)
		// we will create a slider for each variant with a data attribute to reference it, insert them into the modal
		// then we will show / hide them based on the active variant

		That.popupCall = true;

		// 1. call the api (get)
		That.getProductApiCall(prodId).then((data) => {
			const That = this;
			That.price = {};
			That.producItemInfo = {};
			That.firstRun = true;

			// save the data object for future use (if it doesn't exist)
			if (!window.productData[prodId]) {
				window.productData[prodId] = data;
			}

			if (data.result == 'SUCCESS') {
				let res = data.response;
				That.templatePopupQuickView(res);
				That.modal.attr('data-item-type', res.type);
				That.prodType = res.type;
				That.datalayerDataSource = res.datalayerDataSource;

				That.saleAvailability = res.saleAvailability;
				That.contactUsPageLink = res.contactUsPageLink;

				let slider = $modal.find(BLK + 'imgSlider');

				// main slider is the (res.images)
				if (res.images && res.images.length > 0) {
					for (let i = 0; i < res.images.length; i++) {
						let imgSrc = res.images[i].detail;

						// let imgThumbSrc = res.images[i].thumb;
						let imgZoomSrc = res.images[i].zoom;
						let slide = `
							<div class="${CLS}-slide">
								<img data-zoom-image="${imgZoomSrc}" src="${imgSrc}" data-src="data-zoom-image" class="lazy"/>
							</div>
						`;
						slider.append(slide);
					}
					// generic slick options
					let $sliderOptions = {
						dots: false,
						arrows: true,
					};
					slider.slick($sliderOptions);
				}
				// if we have variants, we will loop through them and get the slider ready for each variant
				if (res.variants && res.variants.length > 0) {
					// loop through variants
					for (let i = 0; i < res.variants.length; i++) {
						let variantCode = res.variants[i].code;
						let variantImages = res.variants[i].images;
						let variantPrice = res.variants[i].price;
						let paymentInfo = res.variants[i].paymentInfo;
						That.price[variantCode] = variantPrice;

						if (!That.paymentInfo) That.paymentInfo = {};
						That.paymentInfo[variantCode] = paymentInfo;

						// create the variant slider dom element
						slider.after(`<div class="variant-slider" data-variant-code="${variantCode}"></div>`);
						if (variantImages && variantImages.length > 0) {
							// loop through variant images
							// create a slider for each variant
							for (let i = 0; i < variantImages.length; i++) {
								let imgSrc = variantImages[i].detail;
								let imgZoomSrc = variantImages[i].zoom;
								let slide = `
									<div class="${CLS}-slide">
										<img data-zoom-image="${imgZoomSrc}" src="${imgSrc}" />
									</div>
								`;
								$modal.find(`.variant-slider[data-variant-code="${variantCode}"]`).append(slide);
							}
						}
					}

					// store variants
					That.prodVariants = res.variants;
				}

				That.getVariantCode();

				if ((res.type === 'generic' && res.variants && res.variants[0]) ||
				   ((res.type === 'size' || res.type === 'color') && res.variants && res.variants.length === 1)) {
					That.modal.attr('data-variant-code', res.variants[0].code);
				}

				That.producItemInfo = res;

				// not sure why it's deleted
				// TODO: investigate this further
				// if (That.producItemInfo && That.producItemInfo['variants']) {
				// 	delete That.producItemInfo['variants'];
				// }

				if (res.displayPrice) {
					That.displayPrice = res.displayPrice;
					That.modal.find(BLK + 'modal__price-detail').html(res.displayPrice);
				}

				if (res.bonusBuyBadges) {
					That.bonusBuyBadges = res.bonusBuyBadges;
					That.setBonusBuy();
				}

				// Price should display "displayPrice"
				// Part Payment options (Laybuy, Afterpay, Humm) shouldn't be displayed
				if (That.saleAvailability === 'ISONP') {
					That.modal.find(BLK + 'modal__paymentInfo').addClass('d-none');
				}

				// "Add to Cart" button changes to "Contact Us" using
				if (That.saleAvailability === 'ISOOP' || That.saleAvailability === 'ISONP') {
					That.modal.find('.add-to-cart')
						.attr('title', 'Contact Us')
						.text('Contact Us');
				}

				if (res.paymentInfo) {
					That.paymentInfoInit = res.paymentInfo;
				}



				That.setVisibleProduct();

				if (That.saleAvailability !== 'ISONP') {
					That.setPrice();
				}
				That.setDiscountBadgeOnInit();

				// For auto active only 1 option size/color
				That.modal.find('.productListingBlock-optionsWrapper:not(.d-none) .productListingBlock-option.is-active-variant').each(function(i, el) {
					That.checkWishAndGiftLists(true);
				});
				// For generic
				if (!$modal.find('.productListingBlock-option').length) {
					That.checkWishAndGiftLists(true);
				}

				// re-init addThis
				if (typeof addthis !== 'undefined') {
					// eslint-disable-next-line no-undef
					addthis.layers.refresh();
				}

				$modal.modal('show');

				// push the view to the dataLayer
				let variantCode = $modal.attr('data-variant-code');
				let itemQnty = $modal.find('.quantityInput input').val();

				let productObj = {
					code: variantCode,
					quantity: itemQnty,
					size: $modal.find('.item-size.is-active-variant').text() || '',
				};

				if (!That.prodVariants) That.prodVariants = [];

				if (That.prodVariants.length == 1 && !That.noDLPush) {
					if (That.checkSelectedVariant('cart')) {
						dataLayer.pushProductView(productObj, That.datalayerDataSource);
					}
				}

				// reset
				That.noDLPush = false;
			}

			this.popupCall = false;
			That.checkAUVendor();
		});


		$modal.on('variantChanged', function() {
			// new variant, change the slider
			let variantCode = $modal.attr('data-variant-code');
			let slider = $modal.find(BLK + 'imgSlider');
			let variantSlider = $modal.find(`.variant-slider[data-variant-code="${variantCode}"]`);
			if (variantSlider.length > 0) {
				$modal.find('.product-img').addClass('d-none');
				let variantSliderHtml = $modal.find(`.variant-slider[data-variant-code="${variantCode}"]`).html();
				// unslick
				if (slider.hasClass('slick-initialized')) {
					slider.slick('unslick');
				}
				// add content
				slider.html(variantSliderHtml);
				// init again
				// generic slick options
				let $sliderOptions = {
					dots: false,
					arrows: true,
				};
				slider.slick($sliderOptions);
			} else {
				if (variantCode) {
					// show an image of the product (generic image / default)
					if (slider.hasClass('slick-initialized')) {
						slider.slick('unslick').empty();
					}
					// in this case, no zoom image, so, we just use the same image as a fall back
					let imgZoomSrc = $modal.find('.product-img').attr('src');
					$modal.find('.product-img').removeClass('d-none').attr('data-zoom-image', imgZoomSrc);
				}
			}

			That.checkWishAndGiftLists(true);

			let productObj = {
				code: variantCode,
				quantity: $modal.find('.quantityInput input').val(),
				size: $modal.find('.item-size.is-active-variant').text() || '',
			};

			const isAddToCartErrorsShowing = !!$modal.find('.add-to-cart-errors.is-active').length;

			if (isAddToCartErrorsShowing && That.checkSelectedVariant('cart')) {
				dataLayer.pushProductView(productObj, That.datalayerDataSource);
			}
			That.checkAUVendor();
		});

		// redraw sliders after the modal is up
		// reinit fb and pinterest
		// remove spinners
		$modal.on('shown.bs.modal', function () {
			// initial slider set position to 0
			let slider = $modal.find(BLK + 'imgSlider');
			// a slight delay until handlebar finishes the template generation
			setTimeout(function () {
				if (slider.hasClass('slick-initialized')) {
					slider.slick('setPosition', 0);
				}
			}, 100);

			$('.loading-spinner.plp-spinner').removeClass('is-active');
		});

		$modal.on('hidden.bs.modal', function () {
			// remove all event handlers
			$modal.find('.product-img').addClass('d-none');
			$modal.off();
		});

		$modal.on('click', '.wishlistBtn', function () {
			let $btn = $(this);
			let $pg = $modal.closest('main');
			let code = $modal.attr('data-variant-code');
			let qty = 1;

			if (!$btn.hasClass(CLS_LIST_ADDED)) {
				// check variant selected
				if (!That.checkSelectedVariant('wishlist')) return;
				let addEnpoint = $this.data('addToWishlistEndpoint');
				let param = {
					code: code,
					qty: qty,
				};
				window.itemTitle = $modal.find('.prod-title').text();
				window.itemImg = That.prodImg;
				wishlist.add($pg, $btn, addEnpoint, param).then((lineItemId) => {
					That.variantStates.lineItemId = lineItemId;
				});
			} else {
				let lineItemId = That.variantStates.lineItemId;
				let removeEnpoint = $this.data('removeFromWishlistEndpoint');
				let param = {
					code: lineItemId,
					qty: qty,
				};
				wishlist.remove($pg, $btn, removeEnpoint, param);
			}
		});

		$modal.on('click', '.addToGiftBtn', function() {
			if (!That.checkSelectedVariant('gift registry')) return;
			let $btn = $(this);
			let $pg = $modal.closest('main');
			if (!$btn.hasClass(CLS_LIST_ADDED)) {
				let code = $modal.attr('data-variant-code');
				let qty = $modal.find('.quantityInput input').val();
				const addEnpoint = $this.data('addToGiftRegistryEndpoint');
				let param = {
					id: code,
					quantity: qty,
				};

				giftRegistry.add($pg, addEnpoint, param, (data) => {
					let details = {
						mods: data.message ? 'has-error' : '',
						title: $modal.find('.prod-title').text(),
						addedText: 'Added to gift registry',
						qty: data.quantityActual,
						itemImg: That.prodImg,
						errorMsg: data.message,
					};
					That.showPopper(details);

					if (data.result == 'SUCCESS') {
						$btn.addClass(CLS_LIST_ADDED);
						That.variantStates.giftRegistryLineItemId = data.lineItemId;
						That.variantStates.giftRegistryId = data.giftRegistryId;
					} else {
						$btn.removeClass(CLS_LIST_ADDED);
					}
				});
			} else {
				const removeEnpoint = $this.data('removeGiftRegistryEndpoint');
				let param = {
					id: That.variantStates.giftRegistryLineItemId,
					giftRegistryId: That.variantStates.giftRegistryId,
				};
				giftRegistry.remove($pg, removeEnpoint, param, (data) => {
					if (data.result == 'SUCCESS') {
						$btn.removeClass(CLS_LIST_ADDED);
					}
				});
			}
		});
	}

	setAUVendor(auVendor = false) {
		const $msgAUVendor = this.modal.find('.australian-vendor');
		if (auVendor) {
			$msgAUVendor.removeClass('d-none');
		} else {
			$msgAUVendor.hasClass('d-none') ? '' : $msgAUVendor.addClass('d-none');
		}
	}

	checkAUVendor() {
		const That = this;
		if (window.enableAustraliaSupplier) {
			let optionsSelected = That.modal.find(`.${CLS}-optionsWrapper:not(.d-none) .${CLS}-option.item-size.is-active`);
			let productType = That.modal.attr('data-item-type');
			if (productType === 'color') {
				optionsSelected = That.modal.find(`.${CLS}-options.colors .${CLS}-option.is-active`);
			}
			if (optionsSelected.length) {
				let auVendor = optionsSelected.attr('data-australianvendor') === 'true';
				if (auVendor) {
					That.setAUVendor(true);
				} else {
					That.setAUVendor(false);
				}
			} else {
				if (productType === 'colorsize') {
					That.setAUVendor(false);
				} else {
					// generic
					let auVendor = That.producItemInfo.variants[0].isAustralianVendor;
					That.setAUVendor(auVendor);
				}
			}
		}
	}

	bannerText(className, text, customStyle = {}) {
		return `<div class="productItem-labelWrap"><div class="productItem-label productItem-label--${className}" style="${utils.css(customStyle)}"><span>${text}</span></div></div>`;
	}

	multiBannerText(bannerData) {
		return `<div class="productItem-labelWrap">${bannerData.reduce((acc, item) => (acc += `<div class="productItem-label productItem-label--${item.className || ''}" style="${item.customStyle || ''}"><span>${item.text || ''}</span></div>`), '')}</div>`;
	}

	showPriceText(className, price, isBold) {
		let isBoldClass = isBold ? 'isBold' : '';
		let htmlPrice = `<h4 class="productDetailsPage-${className} ${isBoldClass}">${price}</h4>`;
		return htmlPrice;
	}

	hasSelectedVariant() {
		const That = this;
		// check if there are no options selected, then show the displayPrice instead
		let selectedVariant = true;
		// if no options exist, don't check the add to cart
		let optionsCount = That.modal.find('.productListingBlock-option').length;
		// if no options has been selected
		if (optionsCount > 0) {
			// color only
			let colorOption = That.modal.find(`.${CLS}-options.colors .${CLS}-option.is-active.is-active-variant:not(.has-sizes)`);
			// color and size
			let colorSizeOption = That.modal.find(`.${CLS}-option.has-sizes.is-active.is-active-variant`);
			// size only
			let sizeOption = That.modal.find(`.${CLS}-option.item-size.is-active.is-active-variant`);
			// generic
			let genericOptions = That.modal.find(`.${CLS}-option.generic.is-active.is-active-variant`);
			// no variant has been selected
			if (
				colorOption.length == 0 &&
				colorSizeOption.length == 0 &&
				sizeOption.length == 0 &&
				genericOptions.length == 0
			) {
				// return false
				selectedVariant = false;
			} else {
				if (colorSizeOption.length != 0) {
					let parentId = colorSizeOption.attr('data-variant-code');
					let sizeOption = That.modal.find('[data-parent-itemid="' + parentId + '"]').find('.productListingBlock-option.item-size.is-active.is-active-variant');
					if (sizeOption.length == 0) {
						// return false
						selectedVariant = false;
					}
				}
			}
		}
		return selectedVariant;
	}

	setDiscountBadgeOnInit() {
		const selectedVariant = this.hasSelectedVariant();
		if (selectedVariant) {
			return;
		}

		let bannerText = '';
		let $wrapperBannerText = this.modal.find(BLK + 'productPhoto');
		const { discountPriceDiscountCode, hotPriceDiscountCode, badgeBgColour, isClearancePrice, isKnockDownPrice, isDiscountPrice, isPromotionPrice } = this.producItemInfo;
		const hasBadge = (isClearancePrice && discountPriceDiscountCode) || isClearancePrice || isKnockDownPrice || isDiscountPrice || isPromotionPrice;
		const banners = [];
		const showBadge = () => {
			bannerText = this.multiBannerText(banners);
			if ($wrapperBannerText.length > 0) {
				if ($wrapperBannerText.find('.productItem-labelWrap').length > 0) {
					$wrapperBannerText.find('.productItem-labelWrap').remove();
				}
				if (bannerText) {
					$wrapperBannerText.append(bannerText);
				}
			}
		};

		if ((hotPriceDiscountCode || discountPriceDiscountCode) && !hasBadge) {
			if (hotPriceDiscountCode) {
				banners.push({
					className: 'new',
					text: `HOT PRICE${hotPriceDiscountCode && hotPriceDiscountCode != "HOT PRICE" ? " - " + hotPriceDiscountCode : ''}`,
				});
			}
			if(discountPriceDiscountCode) {
				banners.push({
					className: 'sale',
					text: discountPriceDiscountCode,
					customStyle: utils.getStyle(badgeBgColour ? { background: badgeBgColour } : {}),
				});
			}
			showBadge();
		} else if (discountPriceDiscountCode) {
			if(discountPriceDiscountCode) {
				banners.push({
					className: 'sale',
					text: discountPriceDiscountCode,
					customStyle: utils.getStyle(badgeBgColour ? { background: badgeBgColour } : {}),
				});
				bannerText = this.multiBannerText(banners);
			}
			showBadge();
		}
	}

	setPrice() {
		const That = this;
		let variantCode = That.modal.attr('data-variant-code');
		let $wrapperPrice = That.modal.find(BLK + 'modal__price-detail');
		let $wrapperBannerText = That.modal.find(BLK + 'productPhoto');
		let priceVariant = That.price && That.price[variantCode];
		let clearanceMessage = That.producItemInfo.clearanceMessage;
		let knockDownMessage = window.KNOCKDOWN_STYLING.Text;
		let paymentInfoVariant = That.paymentInfo && That.paymentInfo[variantCode];
		let selectedVariant = That.hasSelectedVariant();

		const initBanner = () => {
			const {isDiscountPrice, isClearancePrice, isKnockDownPrice, isPromotionPrice, discountBadgeBgColour, discountPriceDiscountCode} = That.producItemInfo;
			if (isDiscountPrice || isClearancePrice || isKnockDownPrice || isPromotionPrice || discountPriceDiscountCode) {
				const firstVariantCode = Object.keys(That.price || {})[0];
				const firstVariant = That.price[firstVariantCode] || {};
				const discountCode = firstVariant.discountCode || '';
				const discountBadgeBgColour = firstVariant.discountBadgeBgColour || '';
				const saleCode = firstVariant.saleCode;
				let bannerText = '';
				if (isClearancePrice && discountPriceDiscountCode) {
					const banners = [
						{
							className: 'clearance',
							text: 'CLEARANCE',
						},
					];

					banners.push({
						className: 'discount',
						text: `${utils.getDiscountWithClearanceBadgePrefixText(window.DISCOUNT_WITH_CLEARANCE_STYLE.Text || discountPriceDiscountCode)}`,
						customStyle: utils.getStyle(window.DISCOUNT_WITH_CLEARANCE_STYLE || {}),
					});

					bannerText = That.multiBannerText(banners);
				} else if (isClearancePrice) {
					bannerText = That.bannerText('clearance', 'CLEARANCE');
				} else if (isKnockDownPrice) {
					let banners = [
						{className: 'knockdown', text: window.KNOCKDOWN_STYLING.Badge, customStyle: window.KNOCKDOWN_STYLING.CustomStyle},
					];
					if (discountCode) {
						banners.unshift({className: 'sale', text: `${utils.getDiscountText(discountCode)}`, customStyle: ''});
					}
					bannerText = That.multiBannerText(banners);
				} else if (isDiscountPrice) {
					bannerText = That.bannerText('sale', `${utils.getDiscountText(saleCode)}`, { 'background-color': discountBadgeBgColour });
				} else if (isPromotionPrice) {
					bannerText = That.bannerText('new', 'HOT PRICE');
				}
				if ($wrapperBannerText.length > 0) {
					if ($wrapperBannerText.find('.productItem-labelWrap').length > 0) {
						$wrapperBannerText.find('.productItem-labelWrap').remove();
					}
					if (bannerText) {
						$wrapperBannerText.append(bannerText);
					}
				}
			}
		};

		if (priceVariant && selectedVariant) {
			const {showWasNowFlag, listPrice, salePrice, isDiscountPrice, isClearancePrice, isKnockDownPrice, isPromotionPrice, saleCode, discountCode, discountBadgeBgColour} = priceVariant;
			(listPrice.amount) ? listPrice.amount = Number(listPrice.amount).toFixed(2) : null;
			(salePrice.amount) ? salePrice.amount = Number(salePrice.amount).toFixed(2) : null;

			let detailDisplay = '';
			let bannerText = '';
			let originPrice = listPrice.amount ? That.showPriceText('normalPrice', `Was $${listPrice.amount}`) : '';
			let nowPrice = salePrice.amount ? That.showPriceText('nowPrice', `Now $${salePrice.amount}`) : '';
			let normalPrice = salePrice.amount ? That.showPriceText('normalPrice', `$${salePrice.amount}`) : '';
			let nowPriceBold = salePrice.amount ? That.showPriceText('nowPrice isBold', `Now $${salePrice.amount}`) : '';

			if (isClearancePrice && isDiscountPrice) {
				detailDisplay = nowPriceBold;
				const banners = [
					{
						className: 'clearance',
						text: 'CLEARANCE',
					},
				];

				if (isDiscountPrice) {
					banners.push({
						className: 'discount',
						text: `${utils.getDiscountWithClearanceBadgePrefixText(discountCode)}`,
						customStyle: utils.getStyle(window.DISCOUNT_WITH_CLEARANCE_STYLE || {}),
					});
				}
				bannerText = That.multiBannerText(banners);
			} else if (isClearancePrice) {
				detailDisplay = nowPriceBold;
				bannerText = That.bannerText('clearance', 'CLEARANCE');

			} else if (isKnockDownPrice) {
				detailDisplay = nowPriceBold;
				detailDisplay += `<p class="productItem-subTitle">${knockDownMessage ? knockDownMessage : ''}</p>`;
				let banners = [
					{className: 'knockdown', text: window.KNOCKDOWN_STYLING.Badge, customStyle: window.KNOCKDOWN_STYLING.CustomStyle},
				];
				if (discountCode) {
					banners.unshift({className: 'sale', text: `${discountCode}`, customStyle: ''});
				}
				bannerText = That.multiBannerText(banners);
			} else if (isDiscountPrice) {
				bannerText = That.bannerText('sale', utils.getDiscountText(saleCode), { 'background-color': discountBadgeBgColour });
				detailDisplay = nowPriceBold;
			} else if (isPromotionPrice) {
				bannerText = That.bannerText('new', 'HOT PRICE');
				if (showWasNowFlag) {
					detailDisplay = originPrice + nowPrice;
				} else {
					detailDisplay = nowPrice;
				}
			} else {
				detailDisplay = normalPrice;
			}
			$wrapperPrice.html(detailDisplay);

			if ($wrapperBannerText.length > 0) {
				if ($wrapperBannerText.find('.productItem-labelWrap').length > 0) {
					$wrapperBannerText.find('.productItem-labelWrap').remove();
				}
				if (bannerText) {
					$wrapperBannerText.append(bannerText);
				}
			}

			// prices for partpayment variants
			if (paymentInfoVariant && paymentInfoVariant.length > 0) {
				for (let i = 0; i < paymentInfoVariant.length; i++) {
					That.modal.find(`.paymentInfo-detail[data-name="${paymentInfoVariant[i].name}"] .payment-desc`).html(paymentInfoVariant[i].desc);
				}
			}
		} else if (!priceVariant) {
			initBanner();
		} else {
			// show display price
			if (That.displayPrice) {
				$wrapperPrice.html(`${That.displayPrice}`);
			}

			// display prices for partpayment variants
			if (That.paymentInfoInit && That.paymentInfoInit.length > 0) {
				for (let i = 0; i < That.paymentInfoInit.length; i++) {
					That.modal.find(`.paymentInfo-detail[data-name="${That.paymentInfoInit[i].name}"] .payment-desc`).html(That.paymentInfoInit[i].desc);
				}
			}
		}
	}

	setBonusBuy() {
		const That = this;
		const $blk = That.modal;
		let variantCode = $blk.attr('data-variant-code');
		if ($blk.attr('data-generic-sku') && $blk.attr('data-item-type') == 'generic') {
			variantCode = $blk.attr('data-generic-sku');
		}
		let $wrapperBonusBuy = $blk.find(`.${CLS}-bonus-buy`);
		let variantData = That.prodVariants && That.prodVariants.filter((variant) => variant.code === variantCode)[0];
		let selectedVariant = That.hasSelectedVariant();
		let bonusHtml = '';
		const setTempBonus = function(arr) {
			let html = '';
			arr.forEach((item) => {
				const bonusTemp = `<div class="bonus-buy-info">
									<div class="bonus-buy-badge" style="color: ${item.textColor}; background-color: ${item.backgroundColor};">${item.name}</div>
									<div class="badge-desc">
										${item.description} ${item.browseText ? `- <a href="${item.browseUrl}" title="link">${item.browseText}</a>` : ''}
									</div>
								</div>`;
				html = html + bonusTemp;
			});
			return html;
		};
		let bonusBadges = [];
		if (variantData && selectedVariant) {
			bonusBadges = variantData.bonusBuyBadges;
		} else {
			bonusBadges = That.bonusBuyBadges;
		}

		if (bonusBadges.length) {
			bonusHtml = setTempBonus(bonusBadges);
		}
		$wrapperBonusBuy.html(bonusHtml);
	}

	getProductApiCall(prodId) {
		// if we have the product data, return early
		if (this.popupCall && window.productData[prodId]) {
			return Promise.resolve(window.productData[prodId]);
		}

		// get (appends the prodId to the url)
		let $this = $(this.$el);
		let $isClearance = !!window.PRODUCT_LISTING_BLOCK_CONFIG && !!window.PRODUCT_LISTING_BLOCK_CONFIG.ShowOnlyClearance;
		let $endpoint = $this.data('getProductEndpoint') + `${prodId}?isQuickView=true&isClearance=${$isClearance}`;

		return Api.getApi($endpoint);
	}

	getVariantCode() {
		const This = this;
		This.getVariantCodeCall();
	}

	getVariantCodeCall() {
		let This = this;
		let prodType = This.modal.attr('data-item-type');
		let itemCode = This.modal.attr('data-item-code');
		let colorSku = This.modal.find(BLK + 'options.colors .is-active-variant').data('sku') || null;
		let sizeSku = This.modal.find(BLK + 'options.sizes .is-active-variant').data('sku') || null;

		if (prodType === 'colorsize') {
			sizeSku = This.modal.find(BLK + 'optionsWrapper:not(.d-none)  .sizes .is-active-variant').data('sku') || null;
		}

		let variantCode;
		switch (prodType) {
			case 'size':
				variantCode = sizeSku;
				break;
			case 'color':
				variantCode = colorSku;
				break;
			case 'colorsize':
				variantCode = sizeSku;
				break;
			case 'generic':
				variantCode = itemCode;
				break;
		}

		This.modal.attr('data-variant-code', variantCode);
	}

	addToBag() {
		const This = this;
		const $blk = $(this.$el);
		const $error = $blk.find(`${BLK}error`);
		// toggle spinners
		$('.loading-spinner.plp-spinner').addClass(CLS_ACTIVE);

		// reset the error msg
		This.modal.find('.error-messages.add-to-cart-errors').text('');
		This.modal.find('.error-messages.add-to-cart-errors').removeClass(CLS_ACTIVE);
		$error.removeClass(CLS_ACTIVE);

		if (!This.checkSelectedVariant('cart')) return;

		let prop = this.prepareProductProp();
		addToCart(prop, () => {
			// success callback
			this.modal.modal('hide');
			$('.loading-spinner.plp-spinner').removeClass(CLS_ACTIVE);
		}, (data) => {
			// fail callback
			// show error div
			this.modal.find('.error-messages.add-to-cart-errors').addClass(CLS_ACTIVE).text(data.message);
			$('.loading-spinner.plp-spinner').removeClass(CLS_ACTIVE);
		});
	}

	prepareProductProp() {
		let itemCode = this.modal.attr('data-variant-code');
		let itemQty = this.modal.find('.quantityInput input').val();

		return {
			endpoint: $('.endpoints-definition').data('add-to-bag-endpoint') || '',
			code: itemCode,
			quantity: itemQty,
			size: '',
			datalayerDataSource: this.datalayerDataSource,
			title: this.modal.find('.prod-title').text() || '',
			cartLink: this.$blk.data('cartLink') || '#',
			prodImg: this.prodImg || ''
		};
	}

	showPopper(data) {
		// only for visible blocks
		// because we have 4 blocks on the styleguide
		if ($(this.$el).is(':visible')) {
			// register the template
			let partial = require('../../../widgets/notifications/tmpl/notifications.hbs');
			Handlebars.registerPartial('notifications', partial);
			let theTemplateScript = `
				{{> notifications wg="notifications" ns="Notifications" }}
			`;
			let precompiled = new Function('return ' + Handlebars.precompile(theTemplateScript))();
			let theTemplate = Handlebars.template(precompiled);
			let theCompiledHtml = theTemplate(data);
			$(document).find('body').append(theCompiledHtml);
			// Re-init script for notifications widget
			loadNotifications(document.body, false, true).then((wg) => {
				wg ? wg.init(data.recommendationsApi) : '';
			}).catch((error) => `${error} An error occurred while loading notifications script`);
		}
	}

	checkSelectedVariant(state) {
		const This = this;
		let errorMsg = `Please select product options before adding this product to your ${state}`;

		// reset errors
		This.modal.find('.error-messages.add-to-cart-errors').text('').removeClass('is-active');

		// if no variant code selected
		// if no options exist, don't check the add to cart
		let optionsCount = This.modal.find(BLK + 'option:visible').length;
		// if no options has been selected
		if (optionsCount > 0) {
			// color only
			let colorOption = This.modal.find(`.${CLS}-options.colors .${CLS}-option.is-active.is-active-variant:not(.has-sizes)`);
			// color and size
			let colorSizeOption = This.modal.find(`.${CLS}-option.has-sizes.is-active.is-active-variant`);
			// size only
			let sizeOption = This.modal.find(`.${CLS}-option.item-size.is-active.is-active-variant`);
			// generic
			let genericOptions = This.modal.find(`.${CLS}-option.generic.is-active.is-active-variant`);

			// no variant has been selected
			if (
				colorOption.length == 0 &&
				colorSizeOption.length == 0 &&
				sizeOption.length == 0 &&
				genericOptions.length == 0
			) {
				This.modal.find('.error-messages.add-to-cart-errors').addClass('is-active').text(errorMsg);
				$('.loading-spinner').removeClass('is-active');
				return false;
			} else {
				if (colorSizeOption.length != 0) {
					let parentId = colorSizeOption.attr('data-variant-code');
					let sizeOption = This.modal.find('[data-parent-itemid="' + parentId + '"]').find(BLK + 'option.item-size.is-active.is-active-variant');
					if (sizeOption.length == 0) {
						This.modal.find('.error-messages.add-to-cart-errors').addClass('is-active').text(errorMsg);
						$('.loading-spinner').removeClass('is-active');
						return false;
					} else {
						return true;
					}
				} else {
					return true;
				}
			}
		} else {
			return true;
		}
	}

	checkWishAndGiftLists(getVariants) {
		const That = this;
		let variant = That.modal.attr('data-variant-code');
		let variantsList = [];

		if (variant && variant != '') {
			if (getVariants) {
				// get wishList and giftList states for the selected variant
				That.getVariantWishListAndGiftState(variant).then((data) => {
					if (data.result == 'SUCCESS') {
						That.variantStates = data.response;
						That.handleWishListAndGiftVariantObj(null, null);
					}
				});
			} else {
				variantsList = That.prodVariants;
				That.handleWishListAndGiftVariantObj(variantsList, variant);
			}
		}
	}

	getVariantWishListAndGiftState(variant) {
		let $endpoint = $(this.$el).data('getWishlistGiftlistStatesEndpoint');
		return Api.getApi($endpoint + variant);
	}

	handleWishListAndGiftVariantObj(variantsList, variant) {
		const That = this;
		let variantObj;

		if (!variantsList && !variant) {
			variantObj = That.variantStates;
		} else {
			variantObj = variantsList.find((item) => {
				return item.code == variant;
			});
		}

		if (variantObj.isAddedIntoGiftRegistry) {
			That.modal.find('.addToGiftBtn').addClass(CLS_LIST_ADDED);
		} else {
			That.modal.find('.addToGiftBtn').removeClass(CLS_LIST_ADDED);
		}

		if (variantObj.isAddedIntoWishlist) {
			That.modal.find('.wishlistBtn').addClass(CLS_LIST_ADDED);
		} else {
			That.modal.find('.wishlistBtn').removeClass(CLS_LIST_ADDED);
		}
	}

}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/396/s/FrontEnd/src/views/blocks/productQuickView/js/productQuickView.js